import React from 'react'
import { LaunchAlertText } from './index.style.js'
import { LaunchAlertWrapper, DismissIcon } from './components.js'

const DISMISSED_BANNER_STORAGE_KEY = 'launchBannerDismissed'

class LaunchAlert extends React.Component {
  constructor(props) {
    super(props)
    const isDismissed =
      window.sessionStorage.getItem(DISMISSED_BANNER_STORAGE_KEY) === 'true'
    this.state = { isDismissed }
  }

  handleDismiss = () => {
    this.setState({ isDismissed: true })
    window.sessionStorage.setItem(DISMISSED_BANNER_STORAGE_KEY, 'true')
  }

  render() {
    if (this.state.isDismissed) return null

    return (
      <LaunchAlertWrapper>
        <LaunchAlertText>
          New Editor application with improved login security launches soon. To
          keep your access, share with us e-mail addresses of employees who use
          the Editor application.{' '}
          <a
            href="https://mailchi.mp/opinary.com/dashboard-launch-signups"
            target="_blank"
            rel="noopener noreferrer"
          >
            Use the form and learn more at the info page
          </a>
          .
        </LaunchAlertText>
        <DismissIcon handleClick={() => this.handleDismiss()} />
      </LaunchAlertWrapper>
    )
  }
}

export default LaunchAlert



// WEBPACK FOOTER //
// ./src/components/LaunchAlert/LaunchAlert.js